module.exports = __webpack_public_path__ + "img/9.96a37e5a.png";